import { render, staticRenderFns } from "./ArvoreProdutosComponent.vue?vue&type=template&id=ebcb649e"
import script from "./ArvoreProdutosComponent.vue?vue&type=script&lang=js"
export * from "./ArvoreProdutosComponent.vue?vue&type=script&lang=js"
import style0 from "./ArvoreProdutosComponent.vue?vue&type=style&index=0&id=ebcb649e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports